// extracted by mini-css-extract-plugin
module.exports = {"SystemLinksEditPage__title":"SystemLinksEditPage_SystemLinksEditPage__title__3sl00"};